import { apiClient } from './client';

export interface CasinoBalance {
  found: boolean;
  balance: number;
  currency: string;
  /**
   * `true` = no se pudo averiguar si el jugador está en esta caja (la plataforma no
   * expone lectura de saldo, o la consulta falló). Distinto de `found: false`, que
   * significa "se consultó y NO está". El panel no debe acusar a un jugador de no
   * pertenecer a la caja por un bache de red.
   */
  indeterminado?: boolean;
}

export interface CasinoOpResult {
  success: boolean;
  amount?: number;
  balanceBefore?: number;
  balanceAfter?: number;
  message?: string;
  /**
   * `true` = el casino NO confirmó la operación y puede haberse aplicado igual.
   * NO es un fallo: si el operador lo lee como "no anduvo" y reintenta, carga dos
   * veces. Se muestra distinto y sin auto-cerrarse.
   */
  ambiguo?: boolean;
}

export const casinoApi = {
  getBalance: async (clientId: string): Promise<CasinoBalance> => {
    const { data } = await apiClient.get<CasinoBalance>('/chat/casino/balance', { params: { clientId } });
    return data;
  },
  deposit: async (clientId: string, amount: number): Promise<CasinoOpResult> => {
    const { data } = await apiClient.post<CasinoOpResult>('/chat/casino/deposit', { clientId, amount });
    return data;
  },
  withdraw: async (clientId: string, amount: number): Promise<CasinoOpResult> => {
    const { data } = await apiClient.post<CasinoOpResult>('/chat/casino/withdraw', { clientId, amount });
    return data;
  },
  register: async (clientId: string): Promise<{ ok: boolean; created?: boolean; linked?: boolean; casinoExternalId?: string; error?: string }> => {
    const { data } = await apiClient.post('/chat/casino/register', { clientId });
    return data;
  },
};
